import React, { useEffect, useRef, useState } from 'react'
import { getImages } from '../const';

const HomeVideo = () => {
    const [openMobAccordion, setOpenMobAccordion] = useState(1);
    useEffect(() => {
        const interval = setInterval(() => {
            setOpenMobAccordion(prev => (prev % 3) + 1); // Cycle through 1, 2, 3
        }, 5000);

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    const handleMobAccordion = (item) => {
        setOpenMobAccordion(item)
    }
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.autoplay = true;
            videoRef.current.muted = true;
            videoRef.current.loop = false;
            videoRef.current.controls = false;
        }
    }, []);

    const [isMobileView, setIsMobileView] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 991);
    };
    const [openGrandOpening, setOpenGrandOpening] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpenGrandOpening(true);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (openGrandOpening) {
            setFadeIn(true);
        }
    }, [openGrandOpening]);
    useEffect(() => {
        const videoElement = videoRef.current;
        const handleVideoEnd = () => {
            videoElement.classList.add('video-fade-in');
            videoElement.play();
            setTimeout(() => {
                // videoElement.currentTime = 0;
                videoElement.classList.remove('video-fade-in');
            }, 3000);
        };
        if (videoElement) {
            videoElement.addEventListener('ended', handleVideoEnd);
        }
        return () => {
            if (videoElement) {
                videoElement.addEventListener('ended', handleVideoEnd);
            }
        };
    }, []);
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        updateView();
        window.addEventListener('resize', handleResize, updateView);
        return () => {
            window.removeEventListener('resize', handleResize, updateView);
        };
    }, []);
  return (
    <>
        <section className="banner-wrap home-banner-wrap py-0">
            {/* <div className='video-block'>
                <div className='video-container'>
                    <iframe width="100%" height="750" src="https://www.youtube.com/embed/2_lpbI6f7X8?si=RvEAIWU9fWN4HmPA&autoplay=1&mute=1&loop=1&playlist=2_lpbI6f7X8&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            </div> */}
            <div className='video-relative'>
                {!isMobile &&   
                    <video className='video-background' width="100%" ref={videoRef} muted loop playsInline autoPlay preload="auto">
                        <source src={`${getImages('banner_video.mp4')}`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video> 
                }
                {isMobile &&   
                    <video className='video-background m-video' width="100%" ref={videoRef} muted loop playsInline autoPlay preload="auto">
                        <source src={`${getImages('banner_video.mp4')}`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                }
            </div>
            <div className='banner-pos'>
                <div className='banner-title wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s"><span className='text-theme'>Experience Excellence</span> <br />Family Owned <br className='xs-mob-br'/>& Operated</div>
                <div className='mt-50 text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="1s">
                    <button className='btn-black-theme' type='button'>View Inventory</button>
                </div>
            </div>
        </section>
    </>
  )
}

export default HomeVideo